import { DynamicComponentLoaderModule } from '@adaptiva/core/loaders';
import { ComboComponentModule } from '@adaptiva/widgets/combo';
import { ObjectExplorerModule } from '@adaptiva/widgets/object-explorer';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocationHierarchyComponent } from './location-hierarchy.component';

@NgModule({
	imports: [
		CommonModule,
		DynamicComponentLoaderModule.forChild(LocationHierarchyComponent),
		ComboComponentModule,
		ObjectExplorerModule,
	],
	declarations: [LocationHierarchyComponent],
	exports: [LocationHierarchyComponent],
})
export class LocationHierarchyComponentModule { }
